import { CtaButtonStatus } from '@/v2/components/pages/PackageView/hooks/useCtaButtonStatus';

export const STATUS_MAP: Record<
  CtaButtonStatus,
  { buttonText: string; section: string; shouldInstantScrollOnMobile?: true }
> = {
  noFlyingFrom: {
    buttonText: 'Select Your Location',
    section: 'flyingFrom',
  },
  noPackageOption: {
    buttonText: 'Select Package Option',
    section: 'package',
  },
  checkAvailability: {
    buttonText: 'Check Availability',
    section: 'room',
    shouldInstantScrollOnMobile: true,
  },
  changeTravellers: {
    buttonText: 'Change Travellers',
    section: 'room',
    shouldInstantScrollOnMobile: true,
  },
  changeDates: {
    buttonText: 'Change Dates',
    section: 'room',
    shouldInstantScrollOnMobile: true,
  },
  reserve: {
    buttonText: 'Reserve',
    section: 'room',
    shouldInstantScrollOnMobile: true,
  },
};
